import { pdpSharedNotificationMultiplePdpVisitsModalConfig as pdpSharedMultiplePdpVisitsModalConfig } from './PdpSharedNotificationMultiplePdpVisitsModal/pdpSharedNotificationMultiplePdpVisitsModalConfig';
import { pdpSharedNotificationPdpSourcingModalConfig as pdpSharedSourcingModalConfig } from './PdpSharedNotificationPdpSourcingModal/pdpSharedNotificationPdpSourcingModalConfig';
import pdpSharedNotificationTradeRequestAppointmentTooltipConfig from './PdpSharedNotificationTradeRequestAppointmentTooltip/pdpSharedNotificationTradeRequestAppointmentTooltipConfig';

export const pdpSharedNotifications = [
    pdpSharedMultiplePdpVisitsModalConfig,
    pdpSharedSourcingModalConfig,
    pdpSharedNotificationTradeRequestAppointmentTooltipConfig,
];
